import { useEffect, useState } from 'react';
import axios from '../../../api/axiosInstance';
import Loader from './Loader';
import ErrorBox from './ErrorBox';

export default function ReviewsSummary({ businessId }) {
  const [summary, setSummary] = useState(null);
  const [state, setState] = useState('loading'); // loading | ready | error

  useEffect(() => {
    setState('loading');
    axios
      .get('/dashboard/reviews-summary', { params: { business_id: businessId } })
      .then(({ data }) => {
        setSummary(data);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, [businessId]);

  if (state === 'loading') return <Loader />;
  //if (state === 'error') return <ErrorBox message="Failed to load reviews." />;
  if (state === 'error') return null;
  
  const stars = Math.round(summary.avg_rating ?? 0);

  return (
    <section className="flex flex-col items-center justify-center gap-3 rounded-lg bg-white p-6 text-center shadow">
      <h2 className="text-lg font-semibold">Reviews</h2>

      <div className="flex items-center gap-1 text-2xl">
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i}>{i < stars ? '⭐' : '☆'}</span>
        ))}
      </div>

      <p className="text-sm text-gray-600">
        {summary.total_reviews} reviewer{summary.total_reviews !== 1 && 's'}
      </p>

      <a
        href={`/dashboard/export-reviews?business_id=${businessId}`}
        className="rounded-md border border-gray-300 bg-white px-3 py-1 text-sm hover:bg-gray-100"
      >
        Download Reviews (.csv)
      </a>
    </section>
  );
}
